import { styled } from "@mui/system";

export const CategoryContainer = styled("div")({
    marginTop: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    padding: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    width: "100%",
    position: "relative",
});

export const CategoryTitle = styled("h3")({
    fontSize: "1.2em",
    fontWeight: "600",
    color: "#fff",
    backgroundColor: "var(--primary-color)", // antes azul
    padding: "10px",
    borderRadius: "4px",
    marginBottom: "20px",
    textAlign: "center",
    textTransform: "uppercase",
});

export const ChartsRow = styled("div")({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
});

export const ChartContainer = styled("div")({
    width: "100%",
    height: "420px",
    backgroundColor: "transparent",
    borderRadius: "8px",
    padding: 0,
    overflow: "visible",
});

export const AreaTotalContainer = styled("div")({
    position: "absolute",
    top: "10px",
    left: "5px",
    borderRadius: "8px",
    padding: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    textAlign: "center",
    fontWeight: "bold",
    minWidth: "120px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#fff",
});

export const VariationDosisContainer = styled("div")({
    position: "absolute",
    top: "100px",
    left: "5px",
    borderRadius: "8px",
    padding: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    textAlign: "center",
    fontWeight: "bold",
    minWidth: "120px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#fff",
});

export const VariationContainer = styled("div")({
    position: "absolute",
    top: "185px",
    left: "5px",
    borderRadius: "8px",
    padding: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    textAlign: "center",
    fontWeight: "bold",
    minWidth: "120px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#fff",
});

export const VariationLabel = styled("div")({
    fontSize: "12px",
    color: "var(--primary-color-dark)", // antes azul
    fontWeight: "bold",
});

export const VariationValue = styled("div")({
    fontSize: "24px",
    color: "var(--primary-color)", // antes azul
    marginTop: "4px",
    fontWeight: "bold",
});

export const CardsGrid = styled("div")({
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "10px",
});
